module.exports = __webpack_public_path__ + "static/image/history/pc/202410.ver2_0_2.jpg?1728ca3f";